
import {
  put, call, takeLatest,
} from 'redux-saga/effects';

import {
  MODALS, API_URLS, FETCH_OPTIONS, SUCCESS_MODALS,
} from '../constants';
import { requestGet, requestPost } from '../utils/request';
import { aGetFeaturesFlagRequest, aUpdateFeaturesFlagRequest } from '../reducers';
import { aSetIsFetching, aSetOpenModal } from '../reducers/common';
import { aGetFeaturesFlagSuccess } from '../reducers/featuresFlag';

/**
 * @memberof sagas/FeaturesFlag
 * @async
 */
function* getFeaturesFlagSaga() {
  try {
    yield put({
      type: aSetIsFetching,
      payload: {
        key: FETCH_OPTIONS.GET_FEATURES_FLAG,
        value: true,
      },
    });

    const response = yield call(requestGet, API_URLS.GET_FEATURES_FLAG, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put({
        type: aGetFeaturesFlagSuccess,
        payload: {
          featuresFlag: response.data.feature_flags,
        },
      });
    }
    yield put(
      {
        type: aSetIsFetching,
        payload: {
          key: FETCH_OPTIONS.GET_FEATURES_FLAG,
          value: false,
        },
      },
    );
  } catch (error) {
    yield put({
      type: aSetOpenModal,
      payload: {
        modal: error.modal || MODALS.GENERAL_ERROR,
        errorMessage: error.message,
        key: FETCH_OPTIONS.GET_FEATURES_FLAG,
        value: false,
      },
    });
  }
}

/**
 * @param {object} action
 */
function* updateFeaturesFlagSaga(action) {
  try {
    yield put({
      type: aSetIsFetching,
      payload: {
        key: FETCH_OPTIONS.UPDATE_FEATURES_FLAG,
        value: true,
      },
    });
    const response = yield call(requestPost, API_URLS.UPDATE_FEATURES_FLAG, action.payload, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put({
        type: aGetFeaturesFlagSuccess,
        payload: {
          featuresFlag: response.data.feature_flags,
        },
      });

      yield put({
        type: aSetOpenModal,
        payload: {
          modal: MODALS.SUCCESS,
          modalData: {
            message: SUCCESS_MODALS.UPDATE_FEATURES_FLAG,
            modal: SUCCESS_MODALS.UPDATE_FEATURES_FLAG,
          },
        },
      });

      yield put(
        {
          type: aSetIsFetching,
          payload: {
            key: FETCH_OPTIONS.UPDATE_FEATURES_FLAG,
            value: false,
          },
        },
      );
    }
  } catch (error) {
    yield put({
      type: aSetOpenModal,
      payload: {
        modal: error.modal || MODALS.GENERAL_ERROR,
        errorMessage: error.message,
        key: FETCH_OPTIONS.UPDATE_FEATURES_FLAG,
        value: false,
      },
    });
  }
}

/**
 * @memberof sagas/FeaturesFlag
 * @async
 * @returns {void}
 */
export default function* FeaturesFlagSaga() {
  yield takeLatest(aGetFeaturesFlagRequest, getFeaturesFlagSaga);
  yield takeLatest(aUpdateFeaturesFlagRequest, updateFeaturesFlagSaga);
}

